import { updateLazy } from 'Functions/lazy';

export const indexSliderOptions = (instance, options) => {
    return {
        effect: 'fade',
        speed: 500,
        loop: false,
        autoplay: {
            delay: 5000,
        },
        on: {
            slideChange(swiper) {
                updateLazy();
            }
        }
    }
}

export const indexTestimonialsOptions = (instance, options) => {
    return {
        effect: 'slide',
        speed: 500,
        loop: false,
        autoplay: {
            delay: 5000,
        }
    }
}
